module.exports = __webpack_public_path__ + "media/images/athletes/107-38d6aae67dcd9aac9f389e15fcddc2db.png";